var items = {
  "block.minecraft.air": "lucht",
  "block.minecraft.stone": "stien",
  "block.minecraft.granite": "graniet",
  "block.minecraft.polished_granite": "gepolèèst graniet",
  "block.minecraft.diorite": "dioriet",
  "block.minecraft.polished_diorite": "gepolèèst dioriet",
  "block.minecraft.andesite": "andesiet",
  "block.minecraft.polished_andesite": "gepolèèst andesiet",
  "block.minecraft.grass_block": "graasblok",
  "block.minecraft.dirt": "èèrde",
  "block.minecraft.coarse_dirt": "groeve èèrde",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "helrôoje nylium",
  "block.minecraft.warped_nylium": "spoèkaetig nylium",
  "block.minecraft.cobblestone": "kaaistien",
  "block.minecraft.oak_planks": "èèkehoutere plaank",
  "block.minecraft.spruce_planks": "sparrenhoutere plaank",
  "block.minecraft.birch_planks": "birkehoutere plaank",
  "block.minecraft.jungle_planks": "oerwoudhoutere plaank",
  "block.minecraft.acacia_planks": "acaciahoutere plaank",
  "block.minecraft.dark_oak_planks": "doenkerèèkehoutere plaank",
  "block.minecraft.crimson_planks": "helrôoje houtere plaank",
  "block.minecraft.warped_planks": "spoèkaetige houtere plaank",
  "block.minecraft.oak_sapling": "èèkekiemplent",
  "block.minecraft.spruce_sapling": "sparrenkiemplent",
  "block.minecraft.birch_sapling": "birkekiemplent",
  "block.minecraft.jungle_sapling": "oerwoudkiemplent",
  "block.minecraft.acacia_sapling": "acaciakiemplent",
  "block.minecraft.dark_oak_sapling": "doenkerèèkekiemplent",
  "block.minecraft.bedrock": "bojemstien",
  "block.minecraft.sand": "zaand",
  "block.minecraft.red_sand": "rooi zaand",
  "block.minecraft.gravel": "grind",
  "block.minecraft.gold_ore": "gawterts",
  "block.minecraft.iron_ore": "èèzererts",
  "block.minecraft.coal_ore": "steenkoolerts",
  "block.minecraft.nether_gold_ore": "nethergawterts",
  "block.minecraft.oak_log": "èèkestam",
  "block.minecraft.spruce_log": "sparrenstam",
  "block.minecraft.birch_log": "birkestam",
  "block.minecraft.jungle_log": "oerwoudstam",
  "block.minecraft.acacia_log": "acaciastam",
  "block.minecraft.dark_oak_log": "doenkerèèkestam",
  "block.minecraft.crimson_stem": "helrôoje stam",
  "block.minecraft.warped_stem": "spoèkaetige stam",
  "block.minecraft.stripped_oak_log": "gestripte eikenstam",
  "block.minecraft.stripped_spruce_log": "gestripte sparrenstam",
  "block.minecraft.stripped_birch_log": "gestripte birkestam",
  "block.minecraft.stripped_jungle_log": "gestripte oerwoudstam",
  "block.minecraft.stripped_acacia_log": "gestripte acaciastam",
  "block.minecraft.stripped_dark_oak_log": "gestripte doenkerèèkestam",
  "block.minecraft.stripped_crimson_stem": "gestripte helrôoje stam",
  "block.minecraft.stripped_warped_stem": "gestripte spoèkaetige stam",
  "block.minecraft.stripped_oak_wood": "gestript èèkehout",
  "block.minecraft.stripped_spruce_wood": "gestript sparrenhout",
  "block.minecraft.stripped_birch_wood": "gestript birkehout",
  "block.minecraft.stripped_jungle_wood": "gestript oerwoudhout",
  "block.minecraft.stripped_acacia_wood": "gestript acaciahout",
  "block.minecraft.stripped_dark_oak_wood": "gestript doenkerèèkehout",
  "block.minecraft.stripped_crimson_hyphae": "gestripte helrôoje schimmeldraoj",
  "block.minecraft.stripped_warped_hyphae": "gestripte spoèkachtige schummeldraoj",
  "block.minecraft.oak_wood": "èèkehout",
  "block.minecraft.spruce_wood": "sparrenhout",
  "block.minecraft.birch_wood": "birkehout",
  "block.minecraft.jungle_wood": "oerwoudhout",
  "block.minecraft.acacia_wood": "acaciahout",
  "block.minecraft.dark_oak_wood": "doenkerèèkehout",
  "block.minecraft.crimson_hyphae": "helrôoje schimmeldraoj",
  "block.minecraft.warped_hyphae": "spoèkaetig schummeldraoj",
  "block.minecraft.oak_leaves": "èèkebloajer",
  "block.minecraft.spruce_leaves": "sparrennaolde",
  "block.minecraft.birch_leaves": "birkebloajer",
  "block.minecraft.jungle_leaves": "oerwoudblaojer",
  "block.minecraft.acacia_leaves": "acaciablaojer",
  "block.minecraft.dark_oak_leaves": "doenkerèèkebloajer",
  "block.minecraft.sponge": "spons",
  "block.minecraft.wet_sponge": "naote spons",
  "block.minecraft.glass": "glaos",
  "block.minecraft.lapis_ore": "lapis lazuli-erts",
  "block.minecraft.lapis_block": "lapis lazuliblok",
  "block.minecraft.dispenser": "dispenser",
  "block.minecraft.sandstone": "zaandstien",
  "block.minecraft.chiseled_sandstone": "gebeiteld zaandstien",
  "block.minecraft.cut_sandstone": "gesneeje zaandstien",
  "block.minecraft.note_block": "nootblok",
  "block.minecraft.powered_rail": "andrèèfrels",
  "block.minecraft.detector_rail": "detectierels",
  "block.minecraft.sticky_piston": "kleefzúúger",
  "block.minecraft.cobweb": "spiennekoppenet",
  "block.minecraft.grass": "hoeg graas",
  "block.minecraft.fern": "varen",
  "block.minecraft.dead_bush": "dooie struuk",
  "block.minecraft.seagrass": "ziejegraas",
  "block.minecraft.sea_pickle": "ziejekraal",
  "block.minecraft.piston": "zúúger",
  "block.minecraft.white_wool": "wiete wól",
  "block.minecraft.orange_wool": "oranje wól",
  "block.minecraft.magenta_wool": "magenta wól",
  "block.minecraft.light_blue_wool": "liechtblaawe wól",
  "block.minecraft.yellow_wool": "gele wól",
  "block.minecraft.lime_wool": "liechtgrúne wól",
  "block.minecraft.pink_wool": "raaze wól",
  "block.minecraft.gray_wool": "grèèze wól",
  "block.minecraft.light_gray_wool": "liechtgrèèze wól",
  "block.minecraft.cyan_wool": "turquoise wól",
  "block.minecraft.purple_wool": "péérse wól",
  "block.minecraft.blue_wool": "blaawe wól",
  "block.minecraft.brown_wool": "brèùne wól",
  "block.minecraft.green_wool": "grúne wól",
  "block.minecraft.red_wool": "rooie wól",
  "block.minecraft.black_wool": "zwerte wól",
  "block.minecraft.dandelion": "pèèrdublom",
  "block.minecraft.poppy": "klaproes",
  "block.minecraft.blue_orchid": "blaawe orchidee",
  "block.minecraft.allium": "look",
  "block.minecraft.azure_bluet": "porseleinsterretje",
  "block.minecraft.red_tulip": "rooie tullep",
  "block.minecraft.orange_tulip": "oranje tullep",
  "block.minecraft.white_tulip": "wiete tullep",
  "block.minecraft.pink_tulip": "raaze tullep",
  "block.minecraft.oxeye_daisy": "margriet",
  "block.minecraft.cornflower": "kollebluumke",
  "block.minecraft.lily_of_the_valley": "lelietje-van-dalen",
  "block.minecraft.wither_rose": "witherroes",
  "block.minecraft.brown_mushroom": "brèùne paddestuul",
  "block.minecraft.red_mushroom": "rooie paddestuul",
  "block.minecraft.crimson_fungus": "helrôoje zwam",
  "block.minecraft.warped_fungus": "spoèkaetige zwam",
  "block.minecraft.crimson_roots": "helrôoje peeje",
  "block.minecraft.warped_roots": "spoèkaetige peej'n",
  "block.minecraft.nether_sprouts": "netherscheuten",
  "block.minecraft.weeping_vines": "hangende klimop",
  "block.minecraft.twisting_vines": "verwikkelde klimop",
  "block.minecraft.sugar_cane": "sokkerriet",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bamboe",
  "block.minecraft.gold_block": "gawtblok",
  "block.minecraft.iron_block": "èèzerblok",
  "block.minecraft.oak_slab": "èèkehoutere plôat",
  "block.minecraft.spruce_slab": "sparrenhoutere plôat",
  "block.minecraft.birch_slab": "birkehoutere plôat",
  "block.minecraft.jungle_slab": "oerwoudhoutere plôat",
  "block.minecraft.acacia_slab": "acaciahoutere plôat",
  "block.minecraft.dark_oak_slab": "doenkerèèkehoutere plôat",
  "block.minecraft.crimson_slab": "helrôoje houtere plôat",
  "block.minecraft.warped_slab": "spoèkaetige houtere plôat",
  "block.minecraft.stone_slab": "stiene plôat",
  "block.minecraft.smooth_stone_slab": "glàje stienen plôat",
  "block.minecraft.sandstone_slab": "zaandstienen plôat",
  "block.minecraft.cut_sandstone_slab": "gesneeje zaandstienen plôat",
  "block.minecraft.petrified_oak_slab": "verstiende èèkehoutere plôat",
  "block.minecraft.cobblestone_slab": "keistienen plôat",
  "block.minecraft.brick_slab": "bakstiene plôat",
  "block.minecraft.stone_brick_slab": "blokstiene plôat",
  "block.minecraft.nether_brick_slab": "netherbakstienen plôat",
  "block.minecraft.quartz_slab": "kwertsplôat",
  "block.minecraft.red_sandstone_slab": "rooie zaandstienen plôat",
  "block.minecraft.cut_red_sandstone_slab": "gesneeje rooie zaandstienen plôat",
  "block.minecraft.purpur_slab": "purpurplôat",
  "block.minecraft.prismarine_slab": "prismarienplôat",
  "block.minecraft.prismarine_brick_slab": "prismarienblokstiene plôat",
  "block.minecraft.dark_prismarine_slab": "doenkerprismarienplôat",
  "block.minecraft.smooth_quartz": "glàje kwertsblok",
  "block.minecraft.smooth_red_sandstone": "glàje rooi zaandstien",
  "block.minecraft.smooth_sandstone": "glàje zaandstien",
  "block.minecraft.smooth_stone": "glàje stien",
  "block.minecraft.bricks": "bakstienen",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "buukekast",
  "block.minecraft.mossy_cobblestone": "mossige keistien",
  "block.minecraft.obsidian": "obsidiaan",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "endstaf",
  "block.minecraft.chorus_plant": "chorusplent",
  "block.minecraft.chorus_flower": "chorusbluumke",
  "block.minecraft.purpur_block": "purpurblok",
  "block.minecraft.purpur_pillar": "purpurpeleer",
  "block.minecraft.purpur_stairs": "purpurtrep",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "èèkehoutere trep",
  "block.minecraft.chest": "kiest",
  "block.minecraft.diamond_ore": "diamanterts",
  "block.minecraft.diamond_block": "diamantblok",
  "block.minecraft.crafting_table": "weirekbaank",
  "block.minecraft.farmland": "laandbaawèèrde",
  "block.minecraft.furnace": "oove",
  "block.minecraft.ladder": "lière",
  "block.minecraft.rail": "rels",
  "block.minecraft.cobblestone_stairs": "keistienen trep",
  "block.minecraft.lever": "hendel",
  "block.minecraft.stone_pressure_plate": "stienen drôkplôat",
  "block.minecraft.oak_pressure_plate": "èèkehoutere drôkplôat",
  "block.minecraft.spruce_pressure_plate": "sparrenhoutere drôkplôat",
  "block.minecraft.birch_pressure_plate": "birkehoutere drôkplôat",
  "block.minecraft.jungle_pressure_plate": "oerwoudhoutere drôkplôat",
  "block.minecraft.acacia_pressure_plate": "acaciahoutere drôkplôat",
  "block.minecraft.dark_oak_pressure_plate": "doenkerèèkehoutere drôkplôat",
  "block.minecraft.crimson_pressure_plate": "helrôoje houtere drôkplôat",
  "block.minecraft.warped_pressure_plate": "spoèkaetige houtere drôkplôat",
  "block.minecraft.polished_blackstone_pressure_plate": "gepolèèste zwertstienen drôkplôat",
  "block.minecraft.redstone_ore": "redstone-erts",
  "block.minecraft.redstone_torch": "redstonefakkel",
  "block.minecraft.snow": "sneuw",
  "block.minecraft.ice": "èès",
  "block.minecraft.snow_block": "sneuwblok",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "klaai",
  "block.minecraft.jukebox": "ploatenspeuler",
  "block.minecraft.oak_fence": "èèkehoutere hekke",
  "block.minecraft.spruce_fence": "sparrenhoutere hekke",
  "block.minecraft.birch_fence": "birkehoutere hekke",
  "block.minecraft.jungle_fence": "oerwoudhoutere hekke",
  "block.minecraft.acacia_fence": "acaciahoutere hekke",
  "block.minecraft.dark_oak_fence": "doenkerèèkehoutere hekke",
  "block.minecraft.crimson_fence": "helrôoje houtere hekke",
  "block.minecraft.warped_fence": "spoèkaetig houtere hekke",
  "block.minecraft.pumpkin": "pompoen",
  "block.minecraft.carved_pumpkin": "beweirekte pompoen",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "zielenzaand",
  "block.minecraft.soul_soil": "zielenèèrde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "gepolèst basalt",
  "block.minecraft.soul_torch": "zielenfakkel",
  "block.minecraft.glowstone": "gleujstien",
  "block.minecraft.jack_o_lantern": "jack-o'-lantern",
  "block.minecraft.oak_trapdoor": "èèkehoutere vaalluuk",
  "block.minecraft.spruce_trapdoor": "sparrenhoutere vaalluuk",
  "block.minecraft.birch_trapdoor": "birkehoutere vaalluuk",
  "block.minecraft.jungle_trapdoor": "oerwoudhoutere vaalluuk",
  "block.minecraft.acacia_trapdoor": "acaciahoutere vaalluuk",
  "block.minecraft.dark_oak_trapdoor": "doenkerèèkehoutere vaalluuk",
  "block.minecraft.crimson_trapdoor": "helrôoje houtere vaalluuk",
  "block.minecraft.warped_trapdoor": "spoèkaetig houtere vaalluuk",
  "block.minecraft.infested_stone": "geïnfecteerde stien",
  "block.minecraft.infested_cobblestone": "geïnfecteerde keistien",
  "block.minecraft.infested_stone_bricks": "geïnfecteerde blokstienen",
  "block.minecraft.infested_mossy_stone_bricks": "geïnfecteerde mossige blokstienen",
  "block.minecraft.infested_cracked_stone_bricks": "geïnfecteerde gebarsten blokstienen",
  "block.minecraft.infested_chiseled_stone_bricks": "geïnfecteerde gebeitelde blokstienen",
  "block.minecraft.stone_bricks": "blokstienen",
  "block.minecraft.mossy_stone_bricks": "mossige blokstienen",
  "block.minecraft.cracked_stone_bricks": "gebarsten blokstienen",
  "block.minecraft.chiseled_stone_bricks": "gebeitelde blokstienen",
  "block.minecraft.brown_mushroom_block": "brèùn paddestuuleblok",
  "block.minecraft.red_mushroom_block": "rooi paddestuuleblok",
  "block.minecraft.mushroom_stem": "paddestuulestam",
  "block.minecraft.iron_bars": "traolies",
  "block.minecraft.chain": "ketting",
  "block.minecraft.glass_pane": "glaoze rute",
  "block.minecraft.melon": "meloenschèèf",
  "block.minecraft.vine": "liaone",
  "block.minecraft.oak_fence_gate": "èèkehoutere poewert",
  "block.minecraft.spruce_fence_gate": "sparrenhoutere poewert",
  "block.minecraft.birch_fence_gate": "birkehoutere poewert",
  "block.minecraft.jungle_fence_gate": "oerwoudhoutere poewert",
  "block.minecraft.acacia_fence_gate": "acaciahoutere poewert",
  "block.minecraft.dark_oak_fence_gate": "doenkerèèkehoutere poewert",
  "block.minecraft.crimson_fence_gate": "helrôoje houtere poewert",
  "block.minecraft.warped_fence_gate": "spoèkaetige houtere poewert",
  "block.minecraft.brick_stairs": "bakstienen trep",
  "block.minecraft.stone_brick_stairs": "blokstienen trep",
  "block.minecraft.mycelium": "zwamvlok",
  "block.minecraft.lily_pad": "woaturlelie",
  "block.minecraft.nether_bricks": "netherbakstienen",
  "block.minecraft.cracked_nether_bricks": "gebarste netherbakstienen",
  "block.minecraft.chiseled_nether_bricks": "gebeitelde netherbakstienen",
  "block.minecraft.nether_brick_fence": "netherbakstienen hekke",
  "block.minecraft.nether_brick_stairs": "netherbakstienen trep",
  "block.minecraft.enchanting_table": "betoveringstoafel",
  "block.minecraft.end_portal_frame": "endpertaolframe",
  "block.minecraft.end_stone": "endstien",
  "block.minecraft.end_stone_bricks": "endblokstienen",
  "block.minecraft.dragon_egg": "draokenaaike",
  "block.minecraft.redstone_lamp": "redstonelempke",
  "block.minecraft.sandstone_stairs": "zaandstienen trep",
  "block.minecraft.emerald_ore": "smaragderts",
  "block.minecraft.ender_chest": "enderkiest",
  "block.minecraft.tripwire_hook": "strunkeldraojhaok",
  "block.minecraft.emerald_block": "smaragdblok",
  "block.minecraft.spruce_stairs": "sparrenhoutere trep",
  "block.minecraft.birch_stairs": "birkehoutere trep",
  "block.minecraft.jungle_stairs": "oerwoudhoutere trep",
  "block.minecraft.crimson_stairs": "helrôoje houtere trep",
  "block.minecraft.warped_stairs": "spoèkaetige houtere trep",
  "block.minecraft.command_block": "opdrachtblok",
  "block.minecraft.beacon": "baken",
  "block.minecraft.cobblestone_wall": "keistienen waand",
  "block.minecraft.mossy_cobblestone_wall": "mossige keistienen waand",
  "block.minecraft.brick_wall": "bakstienen waand",
  "block.minecraft.prismarine_wall": "prismarienwaand",
  "block.minecraft.red_sandstone_wall": "rooie zaandstienen waand",
  "block.minecraft.mossy_stone_brick_wall": "mossige blokstienen waand",
  "block.minecraft.granite_wall": "granietwaand",
  "block.minecraft.stone_brick_wall": "blokstienen waand",
  "block.minecraft.nether_brick_wall": "netherbakstienen waand",
  "block.minecraft.andesite_wall": "andesietwaand",
  "block.minecraft.red_nether_brick_wall": "rooie netherbakstienen waand",
  "block.minecraft.sandstone_wall": "zaandstienen waand",
  "block.minecraft.end_stone_brick_wall": "endblokstienen waand",
  "block.minecraft.diorite_wall": "diorietwaand",
  "block.minecraft.blackstone_wall": "zwertstienen waand",
  "block.minecraft.polished_blackstone_wall": "gepolèèste zwertstienen waand",
  "block.minecraft.polished_blackstone_brick_wall": "gepolèèste zwertstienen blokstienen waand",
  "block.minecraft.stone_button": "stienen knupke",
  "block.minecraft.oak_button": "èèkehoutere knupke",
  "block.minecraft.spruce_button": "sparrenhoutere knupke",
  "block.minecraft.birch_button": "birkehoutere knupke",
  "block.minecraft.jungle_button": "oerwoudhoutere knupke",
  "block.minecraft.acacia_button": "acaciahoutere knupke",
  "block.minecraft.dark_oak_button": "doenkerèèkehoutere knupke",
  "block.minecraft.crimson_button": "helrôoje houtere knupke",
  "block.minecraft.warped_button": "spoèkaetige houtere knupke",
  "block.minecraft.polished_blackstone_button": "gepolèèste zwertstienen knupke",
  "block.minecraft.anvil": "ònbild",
  "block.minecraft.chipped_anvil": "gebarsten ònbild",
  "block.minecraft.damaged_anvil": "beschaodegd ònbild",
  "block.minecraft.trapped_chest": "kiest meej valstrik",
  "block.minecraft.light_weighted_pressure_plate": "liechte drôkgevoelège plôat",
  "block.minecraft.heavy_weighted_pressure_plate": "zwaore drôkgevoelège plôat",
  "block.minecraft.daylight_detector": "daogliechtsensor",
  "block.minecraft.redstone_block": "redstoneblok",
  "block.minecraft.nether_quartz_ore": "netherkwertserts",
  "block.minecraft.hopper": "trefter",
  "block.minecraft.chiseled_quartz_block": "gebeiteld kwertsblok",
  "block.minecraft.quartz_block": "kwertsblok",
  "block.minecraft.quartz_bricks": "kwertsblokstienen",
  "block.minecraft.quartz_pillar": "kwertspeleer",
  "block.minecraft.quartz_stairs": "kwertstrep",
  "block.minecraft.activator_rail": "activaosierels",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "wiet terracotta",
  "block.minecraft.orange_terracotta": "oranje terracotta",
  "block.minecraft.magenta_terracotta": "magenta terracotta",
  "block.minecraft.light_blue_terracotta": "liechtblaaw terracotta",
  "block.minecraft.yellow_terracotta": "gèèl terracotta",
  "block.minecraft.lime_terracotta": "liechtgrún terracotta",
  "block.minecraft.pink_terracotta": "raaze terracotta",
  "block.minecraft.gray_terracotta": "grèès terracotta",
  "block.minecraft.light_gray_terracotta": "liechtgrèès terracotta",
  "block.minecraft.cyan_terracotta": "turquoise terracotta",
  "block.minecraft.purple_terracotta": "péérs terracotta",
  "block.minecraft.blue_terracotta": "blaaw terracotta",
  "block.minecraft.brown_terracotta": "brèùn terracotta",
  "block.minecraft.green_terracotta": "grún terracotta",
  "block.minecraft.red_terracotta": "rooi terracotta",
  "block.minecraft.black_terracotta": "zwert terracotta",
  "block.minecraft.barrier": "barrière",
  "block.minecraft.iron_trapdoor": "èèzere vaalluuk",
  "block.minecraft.hay_block": "hôojbaol",
  "block.minecraft.white_carpet": "wiet tapijt",
  "block.minecraft.orange_carpet": "oranje tapijt",
  "block.minecraft.magenta_carpet": "magenta tapijt",
  "block.minecraft.light_blue_carpet": "liechtblaaw tapijt",
  "block.minecraft.yellow_carpet": "gèèl tapijt",
  "block.minecraft.lime_carpet": "liechtgrún tapijt",
  "block.minecraft.pink_carpet": "raaze tapijt",
  "block.minecraft.gray_carpet": "grèès tapijt",
  "block.minecraft.light_gray_carpet": "liechtgrèès tapijt",
  "block.minecraft.cyan_carpet": "turquoise tapijt",
  "block.minecraft.purple_carpet": "péérs tapijt",
  "block.minecraft.blue_carpet": "blaaw tapijt",
  "block.minecraft.brown_carpet": "brèùn tapijt",
  "block.minecraft.green_carpet": "grún tapijt",
  "block.minecraft.red_carpet": "rooi tapijt",
  "block.minecraft.black_carpet": "zwert tapijt",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "stienkôolblok",
  "block.minecraft.packed_ice": "pakèès",
  "block.minecraft.acacia_stairs": "acaciahoutere trep",
  "block.minecraft.dark_oak_stairs": "doenkerèèkehoutere trep",
  "block.minecraft.slime_block": "sleumblok",
  "block.minecraft.grass_path": "graaspad",
  "block.minecraft.sunflower": "zonnebluum",
  "block.minecraft.lilac": "sering",
  "block.minecraft.rose_bush": "roêzestruuk",
  "block.minecraft.peony": "pioenroes",
  "block.minecraft.tall_grass": "hoèg graas",
  "block.minecraft.large_fern": "groewte varen",
  "block.minecraft.white_stained_glass": "wietgekleurd glaos",
  "block.minecraft.orange_stained_glass": "oranjegekleurd glaos",
  "block.minecraft.magenta_stained_glass": "magentagekleurd glaos",
  "block.minecraft.light_blue_stained_glass": "liechtblaawgekleurd glaos",
  "block.minecraft.yellow_stained_glass": "gèèlgekleurd glaos",
  "block.minecraft.lime_stained_glass": "liechtgrúngekleurd glaos",
  "block.minecraft.pink_stained_glass": "raasgekleurd glaos",
  "block.minecraft.gray_stained_glass": "grèèsgekleurd glaos",
  "block.minecraft.light_gray_stained_glass": "liechtgrèèsgekleurd glaos",
  "block.minecraft.cyan_stained_glass": "turquoisegekleurd glaos",
  "block.minecraft.purple_stained_glass": "péérsgekleurd glaos",
  "block.minecraft.blue_stained_glass": "blaawgekleurd glaos",
  "block.minecraft.brown_stained_glass": "brèùngekleurd glaos",
  "block.minecraft.green_stained_glass": "grúngekleurd glaos",
  "block.minecraft.red_stained_glass": "rooigekleurd glaos",
  "block.minecraft.black_stained_glass": "zwètgekleurd glaos",
  "block.minecraft.white_stained_glass_pane": "wietgekleurd glaos",
  "block.minecraft.orange_stained_glass_pane": "oranjegekleurd glaoze rute",
  "block.minecraft.magenta_stained_glass_pane": "magentagekleurde glaoze rute",
  "block.minecraft.light_blue_stained_glass_pane": "liechtblaawgekleurde glaoze rute",
  "block.minecraft.yellow_stained_glass_pane": "gèèlgekleurde glaoze rute",
  "block.minecraft.lime_stained_glass_pane": "liechtgrúngekleurde glaoze rute",
  "block.minecraft.pink_stained_glass_pane": "raasgekleurde glaoze rute",
  "block.minecraft.gray_stained_glass_pane": "grèèsgekleurde glaoze rute",
  "block.minecraft.light_gray_stained_glass_pane": "liechtgrèèsgekleurde glaoze rute",
  "block.minecraft.cyan_stained_glass_pane": "cyaangekleurde glaoze rute",
  "block.minecraft.purple_stained_glass_pane": "péérsgekleurde glaoze rute",
  "block.minecraft.blue_stained_glass_pane": "blaawgekleurde glaoze rute",
  "block.minecraft.brown_stained_glass_pane": "brèùngekleurde glaoze rute",
  "block.minecraft.green_stained_glass_pane": "grúngekleurde glaoze rute",
  "block.minecraft.red_stained_glass_pane": "rooigekleurde glaoze rute",
  "block.minecraft.black_stained_glass_pane": "zwètgekleurde glaoze rute",
  "block.minecraft.prismarine": "prismarien",
  "block.minecraft.prismarine_bricks": "prismarienblokstienen",
  "block.minecraft.dark_prismarine": "doenkerprismarien",
  "block.minecraft.prismarine_stairs": "prismarientrep",
  "block.minecraft.prismarine_brick_stairs": "prismarienblokstienen trep",
  "block.minecraft.dark_prismarine_stairs": "doenkerprismarientrep",
  "block.minecraft.sea_lantern": "ziejelantèère",
  "block.minecraft.red_sandstone": "rooi zaandstien",
  "block.minecraft.chiseled_red_sandstone": "gebeiteld rooi zaandstien",
  "block.minecraft.cut_red_sandstone": "gesneeje rooi zaandstien",
  "block.minecraft.red_sandstone_stairs": "rooie zaandstienen trep",
  "block.minecraft.repeating_command_block": "herhalend opdrachtblok",
  "block.minecraft.chain_command_block": "gekoppeld opdrachtblok",
  "block.minecraft.magma_block": "magmablok",
  "block.minecraft.nether_wart_block": "netherkrèùdblok",
  "block.minecraft.warped_wart_block": "spoèkaetig krèùdblok",
  "block.minecraft.red_nether_bricks": "rooie netherbakstienen",
  "block.minecraft.bone_block": "bottenblok",
  "block.minecraft.structure_void": "konstruksieleegte",
  "block.minecraft.observer": "observeerder",
  "block.minecraft.shulker_box": "shulkerdoâs",
  "block.minecraft.white_shulker_box": "wiete shulkerdoâs",
  "block.minecraft.orange_shulker_box": "oranje shulkerdoâs",
  "block.minecraft.magenta_shulker_box": "magenta shulkerdoâs",
  "block.minecraft.light_blue_shulker_box": "liechtblaawe shulkerdoâs",
  "block.minecraft.yellow_shulker_box": "gele shulkerdoâs",
  "block.minecraft.lime_shulker_box": "liechtgrúne shulkerdoâs",
  "block.minecraft.pink_shulker_box": "raaze shulkerdoâs",
  "block.minecraft.gray_shulker_box": "grèèze shulkerdoâs",
  "block.minecraft.light_gray_shulker_box": "liechtgrèèze shulkerdoâs",
  "block.minecraft.cyan_shulker_box": "turquoise shulkerdoâs",
  "block.minecraft.purple_shulker_box": "péérse shulkerdoâs",
  "block.minecraft.blue_shulker_box": "blaawe shulkerdoâs",
  "block.minecraft.brown_shulker_box": "brèùne shulkerdoâs",
  "block.minecraft.green_shulker_box": "grúne shulkerdoâs",
  "block.minecraft.red_shulker_box": "rooie shulkerdoâs",
  "block.minecraft.black_shulker_box": "zwerte shulkerdoâs",
  "block.minecraft.white_glazed_terracotta": "wietgeglaozuurde terracotta",
  "block.minecraft.orange_glazed_terracotta": "oranjegeglaozuurde terracotta",
  "block.minecraft.magenta_glazed_terracotta": "magentageglaozuurde terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "liechtblaawgeglaozuurde terracotta",
  "block.minecraft.yellow_glazed_terracotta": "gèèlgeglaozuurde terracotta",
  "block.minecraft.lime_glazed_terracotta": "liechtgrúngeglaozuurde terracotta",
  "block.minecraft.pink_glazed_terracotta": "raazegeglaozuurde terracotta",
  "block.minecraft.gray_glazed_terracotta": "grèèsgeglaozuurde terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "liechtgrèèsgeglaozuurde terracotta",
  "block.minecraft.cyan_glazed_terracotta": "turquoisegeglaozuurde terracotta",
  "block.minecraft.purple_glazed_terracotta": "péérsgeglaozuurde terracotta",
  "block.minecraft.blue_glazed_terracotta": "blaawgeglaozuurde terracotta",
  "block.minecraft.brown_glazed_terracotta": "brèùngeglaozuurde terracotta",
  "block.minecraft.green_glazed_terracotta": "grúngeglaozuurde terracotta",
  "block.minecraft.red_glazed_terracotta": "rooigeglaozuurde terracotta",
  "block.minecraft.black_glazed_terracotta": "zwertgeglaozuurde terracotta",
  "block.minecraft.white_concrete": "wiet beton",
  "block.minecraft.orange_concrete": "oranje beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "liechtblaaw beton",
  "block.minecraft.yellow_concrete": "gèèl beton",
  "block.minecraft.lime_concrete": "liechtgrún beton",
  "block.minecraft.pink_concrete": "raaze beton",
  "block.minecraft.gray_concrete": "grèès beton",
  "block.minecraft.light_gray_concrete": "liechtgrèès beton",
  "block.minecraft.cyan_concrete": "turquoise beton",
  "block.minecraft.purple_concrete": "péérs beton",
  "block.minecraft.blue_concrete": "blaaw beton",
  "block.minecraft.brown_concrete": "brèùn beton",
  "block.minecraft.green_concrete": "grún beton",
  "block.minecraft.red_concrete": "rooi beton",
  "block.minecraft.black_concrete": "zwert beton",
  "block.minecraft.white_concrete_powder": "wiet cement",
  "block.minecraft.orange_concrete_powder": "oranje cement",
  "block.minecraft.magenta_concrete_powder": "magenta cement",
  "block.minecraft.light_blue_concrete_powder": "liechtblaaw cement",
  "block.minecraft.yellow_concrete_powder": "gèèl cement",
  "block.minecraft.lime_concrete_powder": "liechtgrún cement",
  "block.minecraft.pink_concrete_powder": "raaze cement",
  "block.minecraft.gray_concrete_powder": "grèès cement",
  "block.minecraft.light_gray_concrete_powder": "liechtgrèès cement",
  "block.minecraft.cyan_concrete_powder": "turquoise cement",
  "block.minecraft.purple_concrete_powder": "péérs cement",
  "block.minecraft.blue_concrete_powder": "blaaw cement",
  "block.minecraft.brown_concrete_powder": "brèùn cement",
  "block.minecraft.green_concrete_powder": "grún cement",
  "block.minecraft.red_concrete_powder": "rooi cement",
  "block.minecraft.black_concrete_powder": "zwert cement",
  "block.minecraft.turtle_egg": "schildpadaaike",
  "block.minecraft.dead_tube_coral_block": "dooi buiskoraalblok",
  "block.minecraft.dead_brain_coral_block": "dooi hersenkoraalblok",
  "block.minecraft.dead_bubble_coral_block": "dooi blaaskoraalblok",
  "block.minecraft.dead_fire_coral_block": "dôot brandkoraalblok",
  "block.minecraft.dead_horn_coral_block": "dooi hoornkoraalblok",
  "block.minecraft.tube_coral_block": "buiskoraalblok",
  "block.minecraft.brain_coral_block": "hersenkoraalblok",
  "block.minecraft.bubble_coral_block": "blaaskoraalblok",
  "block.minecraft.fire_coral_block": "brandkoraalblok",
  "block.minecraft.horn_coral_block": "hoornkoraalblok",
  "block.minecraft.tube_coral": "buiskoraal",
  "block.minecraft.brain_coral": "hersenkoraal",
  "block.minecraft.bubble_coral": "blaaskoraal",
  "block.minecraft.fire_coral": "brandkoraal",
  "block.minecraft.horn_coral": "hoornkoraal",
  "block.minecraft.dead_brain_coral": "dooi hersenkoraal",
  "block.minecraft.dead_bubble_coral": "dooi bubbelkoraal",
  "block.minecraft.dead_fire_coral": "dôot vuurkanaal",
  "block.minecraft.dead_horn_coral": "dooi hoornkoraal",
  "block.minecraft.dead_tube_coral": "dooi buiskoraal",
  "block.minecraft.tube_coral_fan": "buiskoraalwaojer",
  "block.minecraft.brain_coral_fan": "hersenkoraalwaojer",
  "block.minecraft.bubble_coral_fan": "blaaskoraalwaojer",
  "block.minecraft.fire_coral_fan": "brandkoraalwaaier",
  "block.minecraft.horn_coral_fan": "hoornkoraalwaojer",
  "block.minecraft.dead_tube_coral_fan": "dooie buiskoraalwaojer",
  "block.minecraft.dead_brain_coral_fan": "dooie hersenkoraalwaojer",
  "block.minecraft.dead_bubble_coral_fan": "dooie blaaskoraalwaojer",
  "block.minecraft.dead_fire_coral_fan": "dôde brandkoraalwaaier",
  "block.minecraft.dead_horn_coral_fan": "dooie hoornkoraalwaojer",
  "block.minecraft.blue_ice": "blaaw èès",
  "block.minecraft.conduit": "kanaal",
  "block.minecraft.polished_granite_stairs": "gepolèèste graniettrep",
  "block.minecraft.smooth_red_sandstone_stairs": "glàje rooie zaandstienen trep",
  "block.minecraft.mossy_stone_brick_stairs": "mossige blokstienen trep",
  "block.minecraft.polished_diorite_stairs": "gepolèèste dioriettrep",
  "block.minecraft.mossy_cobblestone_stairs": "mossige keistienen trep",
  "block.minecraft.end_stone_brick_stairs": "endblokstienen trep",
  "block.minecraft.stone_stairs": "stienen trep",
  "block.minecraft.smooth_sandstone_stairs": "glàje zaandstienen trep",
  "block.minecraft.smooth_quartz_stairs": "glàje kwertstrep",
  "block.minecraft.granite_stairs": "graniettrep",
  "block.minecraft.andesite_stairs": "andesiettrep",
  "block.minecraft.red_nether_brick_stairs": "rooie netherbakstienen trep",
  "block.minecraft.polished_andesite_stairs": "gepolèèste andesiettrep",
  "block.minecraft.diorite_stairs": "dioriettrep",
  "block.minecraft.polished_granite_slab": "gepolèèste granietplôat",
  "block.minecraft.smooth_red_sandstone_slab": "glàje rooie zaandstienen plôat",
  "block.minecraft.mossy_stone_brick_slab": "mossige blokstienen plôat",
  "block.minecraft.polished_diorite_slab": "gepolèèste diorietplôat",
  "block.minecraft.mossy_cobblestone_slab": "mossige keistienen plôat",
  "block.minecraft.end_stone_brick_slab": "endblokstienen plôat",
  "block.minecraft.smooth_sandstone_slab": "glàje zaandstienen plôat",
  "block.minecraft.smooth_quartz_slab": "glàje kwertsplôat",
  "block.minecraft.granite_slab": "granietplôat",
  "block.minecraft.andesite_slab": "andesietplôat",
  "block.minecraft.red_nether_brick_slab": "rooie netherbakstienen plôat",
  "block.minecraft.polished_andesite_slab": "gepolèèste andesietplôat",
  "block.minecraft.diorite_slab": "diorietplôat",
  "block.minecraft.scaffolding": "staiger",
  "block.minecraft.iron_door": "èèzere deur",
  "block.minecraft.oak_door": "èèkehoutere deur",
  "block.minecraft.spruce_door": "sparrenhoutere deur",
  "block.minecraft.birch_door": "birkehoutere deur",
  "block.minecraft.jungle_door": "oerwoudhoutere deur",
  "block.minecraft.acacia_door": "acaciahoutere deur",
  "block.minecraft.dark_oak_door": "doenkerèèkehoutere deur",
  "block.minecraft.crimson_door": "helrôoje houtere deur",
  "block.minecraft.warped_door": "spoèkaetige houtere deure",
  "block.minecraft.repeater": "redstoneversterker",
  "block.minecraft.comparator": "redstonevergelééker",
  "block.minecraft.structure_block": "konstruksieblok",
  "block.minecraft.jigsaw": "puzzelblok",
  "item.minecraft.turtle_helmet": "schildpadschild□□hoeneer op ut hoofd:□+2 harnas",
  "item.minecraft.scute": "schild",
  "item.minecraft.iron_shovel": "èèzere schup□□hoeneer in hoofdhand:□+3.5 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.iron_pickaxe": "èèzere houweel□□hoeneer in hoofdhand:□+3 aonvalsschaoj□-2.8 aonvalssnelhèèd",
  "item.minecraft.iron_axe": "èèzere bèèl□□hoeneer in hoofdhand:□+8 aonvalsschaoj□-3.1 aonvalssnelhèèd",
  "item.minecraft.flint_and_steel": "allemeur",
  "item.minecraft.apple": "appol",
  "item.minecraft.bow": "baog",
  "item.minecraft.arrow": "pèèl",
  "item.minecraft.coal": "stienkôol",
  "item.minecraft.charcoal": "houtskôol",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "èèzerstaof",
  "item.minecraft.gold_ingot": "gawtstoaf",
  "item.minecraft.netherite_ingot": "netherietstoaf",
  "item.minecraft.netherite_scrap": "netherietschroewt",
  "item.minecraft.iron_sword": "èèzere zwaord□□hoeneer in hoofdhand:□+5 aonvalsschaoj□-2.4 aonvalssnelhèèd",
  "item.minecraft.wooden_sword": "houtere zwaord□□hoeneer in hoofdhand:□+3 aonvalsschaoj□-2.4 aonvalssnelhèèd",
  "item.minecraft.wooden_shovel": "houtere schup□□hoeneer in hoofdhand:□+1.5 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.wooden_pickaxe": "houtere houweel□□hoeneer in hoofdhand:□+1 aonvalsschaoj□-2.8 aonvalssnelhèèd",
  "item.minecraft.wooden_axe": "houtere bèèl□□hoeneer in hoofdhand:□+6 aonvalsschaoj□-3.2 aonvalssnelhèèd",
  "item.minecraft.stone_sword": "stienen zwaord□□hoeneer in hoofdhand:□+4 aonvalsschaoj□-2.4 aonvalssnelhèèd",
  "item.minecraft.stone_shovel": "stienen schup□□hoeneer in hoofdhand:□+2.5 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.stone_pickaxe": "stienen houweel□□hoeneer in hoofdhand:□+2 aonvalsschaoj□-2.8 aonvalssnelhèèd",
  "item.minecraft.stone_axe": "stienen bèèl□□hoeneer in hoofdhand:□+8 aonvalsschaoj□-3.2 aonvalssnelhèèd",
  "item.minecraft.diamond_sword": "diamanten zwaord□□hoeneer in hoofdhand:□+6 aonvalsschaoj□-2.4 aonvalssnelhèèd",
  "item.minecraft.diamond_shovel": "diamanten schup□□hoeneer in hoofdhand:□+4.5 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.diamond_pickaxe": "diamanten houweel□□hoeneer in hoofdhand:□+4 aonvalsschaoj□-2.8 aonvalssnelhèèd",
  "item.minecraft.diamond_axe": "diamanten bèèl□□hoeneer in hoofdhand:□+8 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.stick": "stok",
  "item.minecraft.bowl": "kom",
  "item.minecraft.mushroom_stew": "paddestuulestoofpot",
  "item.minecraft.golden_sword": "gaawe zwaord□□hoeneer in hoofdhand:□+3 aonvalsschaoj□-2.4 aonvalssnelhèèd",
  "item.minecraft.golden_shovel": "gaawe schup□□hoeneer in hoofdhand:□+1.5 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.golden_pickaxe": "gaawe houweel□□hoeneer in hoofdhand:□+1 aonvalsschaoj□-2.8 aonvalssnelhèèd",
  "item.minecraft.golden_axe": "gaawe bèèl□□hoeneer in hoofdhand:□+6 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.netherite_sword": "netherieten zwaord□□hoeneer in hoofdhand:□+7 aonvalsschaoj□-2.4 aonvalssnelhèèd",
  "item.minecraft.netherite_shovel": "netherieten schup□□hoeneer in hoofdhand:□+5.5 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.netherite_pickaxe": "netherieten houweel□□hoeneer in hoofdhand:□+5 aonvalsschaoj□-2.8 aonvalssnelhèèd",
  "item.minecraft.netherite_axe": "netherieten bèèl□□hoeneer in hoofdhand:□+9 aonvalsschaoj□-3 aonvalssnelhèèd",
  "item.minecraft.string": "draoj",
  "item.minecraft.feather": "veer",
  "item.minecraft.gunpowder": "buskrèùd",
  "item.minecraft.wooden_hoe": "houtere schreepel□□hoeneer in hoofdhand:□-3 aonvalssnelhèèd",
  "item.minecraft.stone_hoe": "stienen schreepel□□hoeneer in hoofdhand:□-2 aonvalssnelhèèd",
  "item.minecraft.iron_hoe": "èèzere schrepel□□hoeneer in hoofdhand:□-1 aonvalssnelhèèd",
  "item.minecraft.diamond_hoe": "diamanten schreepel□□hoeneer in hoofdhand:",
  "item.minecraft.golden_hoe": "gaawe schreepel□□hoeneer in hoofdhand:□-3 aonvalssnelhèèd",
  "item.minecraft.netherite_hoe": "netherieten schrepel□□hoeneer in hoofdhand:",
  "item.minecraft.wheat_seeds": "terf zaode",
  "item.minecraft.wheat": "terf",
  "item.minecraft.bread": "brooike",
  "item.minecraft.leather_helmet": "liere kap□□hoeneer op ut hoofd:□+1 harnas",
  "item.minecraft.leather_chestplate": "liere tuniek□□hoeneer op ut lichaam:□+3 harnas",
  "item.minecraft.leather_leggings": "liere boxbin□□hoeneer op d'n bene:□+2 harnas",
  "item.minecraft.leather_boots": "liere lers□□hoeneer op d'n voete:□+1 harnas",
  "item.minecraft.chainmail_helmet": "maliënkapke□□hoeneer op ut hoofd:□+2 harnas",
  "item.minecraft.chainmail_chestplate": "maliën borstploat□□hoeneer op ut lichaam:□+5 harnas",
  "item.minecraft.chainmail_leggings": "maliën bienstukken□□hoeneer op d'n bene:□+4 harnas",
  "item.minecraft.chainmail_boots": "maliën lers□□hoeneer op d'n voete:□+1 harnas",
  "item.minecraft.iron_helmet": "èèzere butsmuts□□hoeneer op ut hoofd:□+2 harnas",
  "item.minecraft.iron_chestplate": "èèzere borstploat□□hoeneer op ut lichaam:□+6 harnas",
  "item.minecraft.iron_leggings": "èèzere bienstukken□□hoeneer op d'n bene:□+5 harnas",
  "item.minecraft.iron_boots": "èèzere lers□□hoeneer op d'n voete:□+2 harnas",
  "item.minecraft.diamond_helmet": "diamanten butsmuts□□hoeneer op ut hoofd:□+3 harnas□+2 harnashardheid",
  "item.minecraft.diamond_chestplate": "diamanten borstploat□□hoeneer op ut lichaam:□+8 harnas□+2 harnashardheid",
  "item.minecraft.diamond_leggings": "diamanten bienstukken□□hoeneer op d'n bene:□+6 harnas□+2 harnashardheid",
  "item.minecraft.diamond_boots": "diamanten laarzen□□hoeneer op d'n voete:□+3 harnas□+2 harnashardheid",
  "item.minecraft.golden_helmet": "gaawe butsmuts□□hoeneer op ut hoofd:□+2 harnas",
  "item.minecraft.golden_chestplate": "gaawe borstploat□□hoeneer op ut lichaam:□+5 harnas",
  "item.minecraft.golden_leggings": "gaawe bienstukken□□hoeneer op d'n bene:□+3 harnas",
  "item.minecraft.golden_boots": "gaawe lers□□hoeneer op d'n voete:□+1 harnas",
  "item.minecraft.netherite_helmet": "netherieten butsmuts□□hoeneer op ut hoofd:□+3 harnas□+3 harnashardheid□+1 terugslagweerstand",
  "item.minecraft.netherite_chestplate": "netherieten borstploat□□hoeneer op ut lichaam:□+8 harnas□+3 harnashardheid□+1 terugslagweerstand",
  "item.minecraft.netherite_leggings": "netherieten bienstukken□□hoeneer op d'n bene:□+6 harnas□+3 harnashardheid□+1 terugslagweerstand",
  "item.minecraft.netherite_boots": "netherieten lers□□hoeneer op d'n voete:□+3 harnas□+3 harnashardheid□+1 terugslagweerstand",
  "item.minecraft.flint": "vuurstien",
  "item.minecraft.porkchop": "raaw kuusvlis",
  "item.minecraft.cooked_porkchop": "gebraoje kuusvlis",
  "item.minecraft.painting": "schildereej",
  "item.minecraft.golden_apple": "gaawe appol",
  "item.minecraft.enchanted_golden_apple": "betoverde gaawe appol",
  "block.minecraft.oak_sign": "èèkehoutere burd",
  "block.minecraft.spruce_sign": "sparrenhoutere burd",
  "block.minecraft.birch_sign": "birkehoutere burd",
  "block.minecraft.jungle_sign": "oerwoudhoutere burd",
  "block.minecraft.acacia_sign": "acaciahoutere burd",
  "block.minecraft.dark_oak_sign": "doenkerèèkehoutere burd",
  "block.minecraft.crimson_sign": "helrôoje houtere burd",
  "block.minecraft.warped_sign": "spoèkaetig houtere burd",
  "item.minecraft.bucket": "eemer",
  "item.minecraft.water_bucket": "eemer woatur",
  "item.minecraft.lava_bucket": "eemer lava",
  "item.minecraft.minecart": "mijnkar",
  "item.minecraft.saddle": "zoal",
  "item.minecraft.redstone": "redstonestobber",
  "item.minecraft.snowball": "sneuwbal",
  "item.minecraft.oak_boat": "èèkehoutere boèt",
  "item.minecraft.leather": "liere",
  "item.minecraft.milk_bucket": "eemer melluk",
  "item.minecraft.pufferfish_bucket": "eemer kûgelvès",
  "item.minecraft.salmon_bucket": "eemer zalm",
  "item.minecraft.cod_bucket": "eemer kabeljauw",
  "item.minecraft.tropical_fish_bucket": "eemer tropische vès",
  "item.minecraft.brick": "bakstien",
  "item.minecraft.clay_ball": "klaaibal",
  "block.minecraft.dried_kelp_block": "gedrêûgd kelpblok",
  "item.minecraft.paper": "pampier",
  "item.minecraft.book": "buuk",
  "item.minecraft.slime_ball": "sleumbal",
  "item.minecraft.chest_minecart": "mijnkar meej kiest",
  "item.minecraft.furnace_minecart": "mijnkar meej oove",
  "item.minecraft.egg": "ai",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "vèsgèèrt",
  "item.minecraft.clock": "klok",
  "item.minecraft.glowstone_dust": "gleujstienstobber",
  "item.minecraft.cod": "raawe kabeljauw",
  "item.minecraft.salmon": "raawe zalm",
  "item.minecraft.tropical_fish": "tropische vès",
  "item.minecraft.pufferfish": "kûgelvès",
  "item.minecraft.cooked_cod": "gebakken kabeljauw",
  "item.minecraft.cooked_salmon": "gebakken zalm",
  "item.minecraft.ink_sac": "enkbuil",
  "item.minecraft.red_dye": "rooie koleurstobber",
  "item.minecraft.green_dye": "grúne koleurstobber",
  "item.minecraft.cocoa_beans": "cacaobonne",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "péérse koleurstobber",
  "item.minecraft.cyan_dye": "turquoise koleurstobber",
  "item.minecraft.light_gray_dye": "liechtgrèèze koleurstobber",
  "item.minecraft.gray_dye": "grèèze koleurstobber",
  "item.minecraft.pink_dye": "raaze koleurstobber",
  "item.minecraft.lime_dye": "liechtgrúne koleurstobber",
  "item.minecraft.yellow_dye": "gele koleurstobber",
  "item.minecraft.light_blue_dye": "liechtblaawe koleurstobber",
  "item.minecraft.magenta_dye": "magenta koleurstobber",
  "item.minecraft.orange_dye": "oranje koleurstobber",
  "item.minecraft.bone_meal": "beendermeel",
  "item.minecraft.blue_dye": "blaawe koleurstobber",
  "item.minecraft.brown_dye": "brèùne koleurstobber",
  "item.minecraft.black_dye": "zwerte koleurstobber",
  "item.minecraft.white_dye": "wiete koleurstobber",
  "item.minecraft.bone": "bot",
  "item.minecraft.sugar": "sokker",
  "block.minecraft.cake": "vloai",
  "block.minecraft.white_bed": "wiet bed",
  "block.minecraft.orange_bed": "oranje bed",
  "block.minecraft.magenta_bed": "magenta bed",
  "block.minecraft.light_blue_bed": "liechtblaaw bed",
  "block.minecraft.yellow_bed": "gèèl bed",
  "block.minecraft.lime_bed": "liechtgrún bed",
  "block.minecraft.pink_bed": "raaze bed",
  "block.minecraft.gray_bed": "grèès bed",
  "block.minecraft.light_gray_bed": "liechtgrèès bed",
  "block.minecraft.cyan_bed": "turquoise bed",
  "block.minecraft.purple_bed": "péérs bed",
  "block.minecraft.blue_bed": "blaaw bed",
  "block.minecraft.brown_bed": "brèùn bed",
  "block.minecraft.green_bed": "grún bed",
  "block.minecraft.red_bed": "rooi bed",
  "block.minecraft.black_bed": "zwert bed",
  "item.minecraft.cookie": "kuukske",
  "item.minecraft.filled_map": "koart□#0",
  "item.minecraft.shears": "scher",
  "item.minecraft.melon_slice": "meloen stukske",
  "item.minecraft.dried_kelp": "gedrêûgde kelp",
  "item.minecraft.pumpkin_seeds": "pompoenpitten",
  "item.minecraft.melon_seeds": "meloenzaode",
  "item.minecraft.beef": "raawe bufsteek",
  "item.minecraft.cooked_beef": "bufsteek",
  "item.minecraft.chicken": "raawe kiekke",
  "item.minecraft.cooked_chicken": "gebraoje kiekke",
  "item.minecraft.rotten_flesh": "bedeureve vlis",
  "item.minecraft.ender_pearl": "enderparel",
  "item.minecraft.blaze_rod": "blazestaf",
  "item.minecraft.ghast_tear": "ghasttraon",
  "item.minecraft.gold_nugget": "gawtklumpke",
  "item.minecraft.nether_wart": "netherkrèùd",
  "item.minecraft.potion": "onmoakbare draank□gin effecten",
  "item.minecraft.glass_bottle": "glaoze flesse",
  "item.minecraft.spider_eye": "spinnenôôg",
  "item.minecraft.fermented_spider_eye": "gefermenteerd spinnenôôg",
  "item.minecraft.blaze_powder": "blazepoejer",
  "item.minecraft.magma_cream": "magmacrème",
  "block.minecraft.brewing_stand": "braawstandoard",
  "block.minecraft.cauldron": "kittel",
  "item.minecraft.ender_eye": "enderôôg",
  "item.minecraft.glistering_melon_slice": "gliensterende meloenschèèf",
  "item.minecraft.bat_spawn_egg": "vlirmèùzespawnei",
  "item.minecraft.bee_spawn_egg": "biejespawnei",
  "item.minecraft.blaze_spawn_egg": "blazespawnei",
  "item.minecraft.cat_spawn_egg": "dakhaozespawnei",
  "item.minecraft.cave_spider_spawn_egg": "grottespinnespawnei",
  "item.minecraft.chicken_spawn_egg": "kiekkespawnei",
  "item.minecraft.cod_spawn_egg": "kabeljauwspawnei",
  "item.minecraft.cow_spawn_egg": "koeienspawnei",
  "item.minecraft.creeper_spawn_egg": "creeperspawnei",
  "item.minecraft.dolphin_spawn_egg": "dolfijnenspawnei",
  "item.minecraft.donkey_spawn_egg": "eezelspawnei",
  "item.minecraft.drowned_spawn_egg": "drenkelingespawnei",
  "item.minecraft.elder_guardian_spawn_egg": "aawebewaokerspawnei",
  "item.minecraft.enderman_spawn_egg": "endermanspawnei",
  "item.minecraft.endermite_spawn_egg": "endermijtspawnei",
  "item.minecraft.evoker_spawn_egg": "oproeperspawnei",
  "item.minecraft.fox_spawn_egg": "vossenspawnei",
  "item.minecraft.ghast_spawn_egg": "ghastspawnei",
  "item.minecraft.guardian_spawn_egg": "bewaokerspawnei",
  "item.minecraft.hoglin_spawn_egg": "hoglinspawnei",
  "item.minecraft.horse_spawn_egg": "peerdespawnei",
  "item.minecraft.husk_spawn_egg": "mummiespawnei",
  "item.minecraft.llama_spawn_egg": "lamaspawnei",
  "item.minecraft.magma_cube_spawn_egg": "magmakubusspawnei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroomspawnei",
  "item.minecraft.mule_spawn_egg": "muileezelspawnei",
  "item.minecraft.ocelot_spawn_egg": "ocelottenspawnei",
  "item.minecraft.panda_spawn_egg": "pandaspawnei",
  "item.minecraft.parrot_spawn_egg": "pappegoiespawnei",
  "item.minecraft.phantom_spawn_egg": "fantomenspawnei",
  "item.minecraft.pig_spawn_egg": "verrukespawnei",
  "item.minecraft.piglin_spawn_egg": "piglinspawnei",
  "item.minecraft.pillager_spawn_egg": "roverspawnei",
  "item.minecraft.polar_bear_spawn_egg": "èèsbèèrespawnei",
  "item.minecraft.pufferfish_spawn_egg": "kûgelviesespawnei",
  "item.minecraft.rabbit_spawn_egg": "knijnenspawnei",
  "item.minecraft.ravager_spawn_egg": "verwoesterspawnei",
  "item.minecraft.salmon_spawn_egg": "zalmspawnei",
  "item.minecraft.sheep_spawn_egg": "schaopespawnei",
  "item.minecraft.shulker_spawn_egg": "shulkerspawnei",
  "item.minecraft.silverfish_spawn_egg": "zilvervissenspawnei",
  "item.minecraft.skeleton_spawn_egg": "skelettenspawnei",
  "item.minecraft.skeleton_horse_spawn_egg": "skeletpeerdespawnei",
  "item.minecraft.slime_spawn_egg": "sleumkubusspawnei",
  "item.minecraft.spider_spawn_egg": "spinnespawnei",
  "item.minecraft.squid_spawn_egg": "enkviesespawnei",
  "item.minecraft.stray_spawn_egg": "verdwaoldespawnei",
  "item.minecraft.strider_spawn_egg": "lavarijerspawnei",
  "item.minecraft.trader_llama_spawn_egg": "handelaorslamaspawnei",
  "item.minecraft.tropical_fish_spawn_egg": "tropischeviesespawnei",
  "item.minecraft.turtle_spawn_egg": "schildpaddespawnei",
  "item.minecraft.vex_spawn_egg": "ergernissespawnei",
  "item.minecraft.villager_spawn_egg": "turpelingespawnei",
  "item.minecraft.vindicator_spawn_egg": "verdedigerspawnei",
  "item.minecraft.wandering_trader_spawn_egg": "rondrèèzendehandelaorsspawnei",
  "item.minecraft.witch_spawn_egg": "heksespawnei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelettenspawnei",
  "item.minecraft.wolf_spawn_egg": "wolvespawnei",
  "item.minecraft.zoglin_spawn_egg": "zoglinspawnei",
  "item.minecraft.zombie_spawn_egg": "zombiespawnei",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepeerdspawnei",
  "item.minecraft.zombie_villager_spawn_egg": "zombieturpelingespawnei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombiepiglinspawnei",
  "item.minecraft.experience_bottle": "magiërsextract",
  "item.minecraft.fire_charge": "vuurbal",
  "item.minecraft.writable_book": "buuk en vèr",
  "item.minecraft.written_book": "geschrève buuk",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "veurwerplèèst",
  "block.minecraft.flower_pot": "blommuhpot",
  "item.minecraft.carrot": "pee",
  "item.minecraft.potato": "erpel",
  "item.minecraft.baked_potato": "gebakke erpel",
  "item.minecraft.poisonous_potato": "giftège erpel",
  "item.minecraft.map": "loze koart",
  "item.minecraft.golden_carrot": "gaawe pee",
  "block.minecraft.skeleton_skull": "skelettenschedel",
  "block.minecraft.wither_skeleton_skull": "witherskelettenschedel",
  "block.minecraft.player_head": "speulerhoofd",
  "block.minecraft.zombie_head": "zombiehoofd",
  "block.minecraft.creeper_head": "creeperhoofd",
  "block.minecraft.dragon_head": "draokenhoofd",
  "item.minecraft.carrot_on_a_stick": "pee an 'n stok",
  "item.minecraft.warped_fungus_on_a_stick": "spoèkaetige zwam an 'n stok",
  "item.minecraft.nether_star": "netherstaar",
  "item.minecraft.pumpkin_pie": "pompoenvloai",
  "item.minecraft.firework_rocket": "vuurpèèl",
  "item.minecraft.firework_star": "vuurweirekstaar",
  "item.minecraft.enchanted_book": "beteuverd buuk",
  "item.minecraft.nether_brick": "netherbakstien",
  "item.minecraft.quartz": "netherkwerts",
  "item.minecraft.tnt_minecart": "mijnkar meej tnt",
  "item.minecraft.hopper_minecart": "mijnkar meej trefter",
  "item.minecraft.prismarine_shard": "prismarienscherf",
  "item.minecraft.prismarine_crystals": "prismarienkristalle",
  "item.minecraft.rabbit": "raaw knijnenvlis",
  "item.minecraft.cooked_rabbit": "gebraoje knijnenvlis",
  "item.minecraft.rabbit_stew": "knijnenstoefpot",
  "item.minecraft.rabbit_foot": "knijnenpotje",
  "item.minecraft.rabbit_hide": "knijnenvel",
  "item.minecraft.armor_stand": "harnashaawer",
  "item.minecraft.iron_horse_armor": "èèzere peerdeharnas",
  "item.minecraft.golden_horse_armor": "gaawe peerdeharnas",
  "item.minecraft.diamond_horse_armor": "diamanten peerdeharnas",
  "item.minecraft.leather_horse_armor": "liere peerdeharnas",
  "item.minecraft.lead": "leijzeel",
  "item.minecraft.name_tag": "naomkòrtje",
  "item.minecraft.command_block_minecart": "mijnkar meej opdrachtblok",
  "item.minecraft.mutton": "raaw schaopenvlis",
  "item.minecraft.cooked_mutton": "gebraoje schaopenvlis",
  "block.minecraft.white_banner": "witte banier",
  "block.minecraft.orange_banner": "oranje banier",
  "block.minecraft.magenta_banner": "magenta banier",
  "block.minecraft.light_blue_banner": "lichtblauwe banier",
  "block.minecraft.yellow_banner": "gele banier",
  "block.minecraft.lime_banner": "lichtgroene banier",
  "block.minecraft.pink_banner": "roze banier",
  "block.minecraft.gray_banner": "grijze banier",
  "block.minecraft.light_gray_banner": "lichtgrijze banier",
  "block.minecraft.cyan_banner": "turquoise banier",
  "block.minecraft.purple_banner": "péérse banier",
  "block.minecraft.blue_banner": "blauwe banier",
  "block.minecraft.brown_banner": "bruine banier",
  "block.minecraft.green_banner": "grúne banier",
  "block.minecraft.red_banner": "rooie banier",
  "block.minecraft.black_banner": "zwerte banier",
  "item.minecraft.end_crystal": "endkristal",
  "item.minecraft.chorus_fruit": "chorusfroët",
  "item.minecraft.popped_chorus_fruit": "gepoft chorusfroët",
  "item.minecraft.beetroot": "béét",
  "item.minecraft.beetroot_seeds": "béétezaoje",
  "item.minecraft.beetroot_soup": "béétesuupke",
  "item.minecraft.dragon_breath": "draokenaosem",
  "item.minecraft.splash_potion": "spattende onmoakbare draank□gin effecten",
  "item.minecraft.spectral_arrow": "spectrale pèèl",
  "item.minecraft.tipped_arrow": "onmoakbare getipte pèèl□gin effecten",
  "item.minecraft.lingering_potion": "aonhaawende onmoakbare draank□gin effecten",
  "item.minecraft.shield": "schild",
  "item.minecraft.elytra": "dekschild",
  "item.minecraft.spruce_boat": "sparrenhoutere boot",
  "item.minecraft.birch_boat": "birkehoutere boot",
  "item.minecraft.jungle_boat": "oerwoudhoutere boot",
  "item.minecraft.acacia_boat": "acaciahoutere bwoat",
  "item.minecraft.dark_oak_boat": "doenkere èèkehoutere bwoat",
  "item.minecraft.totem_of_undying": "totem der onsterfelekhèèd",
  "item.minecraft.shulker_shell": "shulkerschelp",
  "item.minecraft.iron_nugget": "èèzerklumke",
  "item.minecraft.knowledge_book": "buuk der kennus",
  "item.minecraft.debug_stick": "debugstok",
  "item.minecraft.music_disc_13": "meziekplôat□c418 - 13",
  "item.minecraft.music_disc_cat": "meziekplôat□c418 - cat",
  "item.minecraft.music_disc_blocks": "meziekplôat□c418 - blocks",
  "item.minecraft.music_disc_chirp": "meziekplôat□c418 - chirp",
  "item.minecraft.music_disc_far": "meziekplôat□c418 - far",
  "item.minecraft.music_disc_mall": "meziekplôat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "meziekplôat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "meziekplôat□c418 - stal",
  "item.minecraft.music_disc_strad": "meziekplôat□c418 - strad",
  "item.minecraft.music_disc_ward": "meziekplôat□c418 - ward",
  "item.minecraft.music_disc_11": "meziekplôat□c418 - 11",
  "item.minecraft.music_disc_wait": "meziekplôat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "meziekplôat□lena raine - pigstep",
  "item.minecraft.trident": "dreitaand□□hoeneer in hoofdhand:□+8 aonvalsschaoj□-2.9 aonvalssnelhèèd",
  "item.minecraft.phantom_membrane": "fantoommembraon",
  "item.minecraft.nautilus_shell": "nautilusschelp",
  "item.minecraft.heart_of_the_sea": "hèrt van d'n zieje",
  "item.minecraft.crossbow": "krèùsbaog",
  "item.minecraft.suspicious_stew": "gehèèmzinnège stoefpot",
  "block.minecraft.loom": "weefgetouw",
  "item.minecraft.flower_banner_pattern": "banierpetroen□blomwaope",
  "item.minecraft.creeper_banner_pattern": "banierpetroen□creeperwaope",
  "item.minecraft.skull_banner_pattern": "banierpetroen□schedelwaope",
  "item.minecraft.mojang_banner_pattern": "banierpetroen□mojanglogo",
  "item.minecraft.globe_banner_pattern": "banierpetroen□globe",
  "item.minecraft.piglin_banner_pattern": "banierpetroen□sneut",
  "block.minecraft.composter": "compostbak",
  "block.minecraft.barrel": "vaot",
  "block.minecraft.smoker": "raoker",
  "block.minecraft.blast_furnace": "hoègoove",
  "block.minecraft.cartography_table": "kartograofietoafel",
  "block.minecraft.fletching_table": "bevederingstoafel",
  "block.minecraft.grindstone": "slèèpstien",
  "block.minecraft.lectern": "lessenaor",
  "block.minecraft.smithing_table": "smeedstoafel",
  "block.minecraft.stonecutter": "stiensniejer",
  "block.minecraft.bell": "bel",
  "block.minecraft.lantern": "lantèère",
  "block.minecraft.soul_lantern": "zielenlantèère",
  "item.minecraft.sweet_berries": "zuutbizemmen",
  "block.minecraft.campfire": "kampvuurke",
  "block.minecraft.soul_campfire": "zielekampvuurke",
  "block.minecraft.shroomlight": "paddestuuleliecht",
  "item.minecraft.honeycomb": "hoennekgroat",
  "block.minecraft.bee_nest": "bienest",
  "block.minecraft.beehive": "biekörref",
  "item.minecraft.honey_bottle": "hoennekfles",
  "block.minecraft.honey_block": "hoennekblok",
  "block.minecraft.honeycomb_block": "hoennekgroatblok",
  "block.minecraft.lodestone": "zèèlstien",
  "block.minecraft.netherite_block": "netherietblok",
  "block.minecraft.ancient_debris": "aaw puun",
  "block.minecraft.target": "doelwit",
  "block.minecraft.crying_obsidian": "jankend obsidiaan",
  "block.minecraft.blackstone": "zwertstien",
  "block.minecraft.blackstone_slab": "zwertstienen plôat",
  "block.minecraft.blackstone_stairs": "zwertstienen trep",
  "block.minecraft.gilded_blackstone": "verguld zwertstien",
  "block.minecraft.polished_blackstone": "gepolèèst zwertstien",
  "block.minecraft.polished_blackstone_slab": "gepolèèste zwertstienen plôat",
  "block.minecraft.polished_blackstone_stairs": "gepolèèste zwertstienen trep",
  "block.minecraft.chiseled_polished_blackstone": "gebeiteld gepolèèst zwertstien",
  "block.minecraft.polished_blackstone_bricks": "gepolèèste zwertstienen blokstienen",
  "block.minecraft.polished_blackstone_brick_slab": "gepolèèste zwertstienen blockstienen plôat",
  "block.minecraft.polished_blackstone_brick_stairs": "gepolèèste zwertstienen blokstienen trep",
  "block.minecraft.cracked_polished_blackstone_bricks": "gebeiteld gepolèèst zwertstienen blokstienen",
  "block.minecraft.respawn_anchor": "respawnaankér",
}
export const brb = items; 
